import FuseSearch from "./FuseSearch.js";
import FlexSearchAdapter from "./FlexSearchAdapter.js";
import BaseSearchAdapter from "./BaseSearchAdapter.js";

export default class SearchAdapter {
	static TYPE_FUSE = 'fuse';
	static TYPE_FLEX = 'flex';

	static create(type, list = [], options = {}) {
		let textSearcher = null;
		switch(type) {
			case SearchAdapter.TYPE_FLEX: {
				textSearcher = new FlexSearchAdapter(options);
				break;
			}
			case SearchAdapter.TYPE_FUSE: {
				textSearcher = new FuseSearch(options);
				break;
			}
			default: {
				throw new Error('type is invalid');
			}
		}
		return new BaseSearchAdapter(textSearcher);
	}
}
